var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnQueuedState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.151,
    height: 19.448,
    viewBox: "0 0 19.151 19.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e0643f;opacity:0.701;}.b,.c{fill:none;stroke:#e0643f;stroke-linecap:round;stroke-miterlimit:10;}.b{stroke-width:2px;}.c{stroke-linejoin:round;stroke-width:1.75px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.342)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 1.295,
    cy: 1.294,
    rx: 1.295,
    ry: 1.294,
    transform: "translate(4.728)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 1.295,
    cy: 1.294,
    rx: 1.295,
    ry: 1.294,
    transform: "translate(1.632 2.476)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 1.295,
    cy: 1.294,
    rx: 1.295,
    ry: 1.294,
    transform: "translate(0 6.022)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 1.295,
    cy: 1.294,
    rx: 1.295,
    ry: 1.294,
    transform: "translate(0.113 10.131)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 1.295,
    cy: 1.294,
    rx: 1.295,
    ry: 1.294,
    transform: "translate(1.745 13.62)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 1.295,
    cy: 1.294,
    rx: 1.295,
    ry: 1.294,
    transform: "translate(4.84 16.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1315.636,1456.079s7.925.747,7.921,8.583c0,7.86-7.624,8.8-7.921,8.713",
    transform: "translate(-1305.405 -1455.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1292.56,1495.721l1.673,1.427,4.578-4.381",
    transform: "translate(-1286.048 -1486.36)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnQueuedState);
export default __webpack_public_path__ + "static/media/icn-queued-state.369be0bd4f7fdee165c519b6876170e1.svg";
export { ForwardRef as ReactComponent };